import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'
import { isThinRegistrationBaseOutput, ThinRegistrationBaseOutput } from './thin-registration-base-output.model'

export interface CheckEmailOutput extends ThinRegistrationBaseOutput, BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  OTPEmailRequestBlockedUntil: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isCheckEmailOutput = (obj: any): obj is CheckEmailOutput => {
  const otpEmailRequestBlockedUntil = 'OTPEmailRequestBlockedUntil'

  return isThinRegistrationBaseOutput && isBaseOutput(obj) && has(obj, otpEmailRequestBlockedUntil)
}
